module.exports = __webpack_public_path__ + "html/frontpage.template.html";